import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.map.js";
import api from '@/api';
import { ElMessage } from 'element-plus';
import TextAnalogyQuestion from './TextAnalogyQuestion.vue';
const emptyOptions = () => ['A', 'B', 'C', 'D'].map(key => ({
  key,
  text: ''
}));
export default {
  name: 'TextAnalogyQuestionForm',
  components: {
    TextAnalogyQuestion
  },
  props: {
    question: {
      type: Object,
      default: null
    },
    groupId: {
      type: Number,
      required: true
    }
  },
  emits: ['saved', 'cancel'],
  data() {
    const validateStem = (rule, value, callback) => {
      const count = (String(value || '').match(/____/g) || []).length;
      count === 1 ? callback() : callback(new Error('题干必须且只能包含一个 ____ 空位'));
    };
    const validateOptions = (rule, value, callback) => {
      value?.length === 4 && value.every(item => item.text?.trim()) ? callback() : callback(new Error('请填写完整的四个选项'));
    };
    return {
      saving: false,
      form: {},
      rules: {
        instructionText: [{
          required: true,
          message: '请输入作答说明',
          trigger: 'blur'
        }],
        stemText: [{
          required: true,
          validator: validateStem,
          trigger: 'blur'
        }],
        options: [{
          validator: validateOptions,
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    previewQuestion() {
      return {
        ...this.form,
        contentMode: 'VERBAL_ANALOGY'
      };
    }
  },
  watch: {
    question: {
      handler: 'resetForm',
      immediate: true
    }
  },
  methods: {
    resetForm() {
      const source = this.question || {};
      this.form = {
        id: source.id || null,
        questionGroupId: this.groupId,
        instructionText: source.instructionText || '“____”处填入哪个词能构成最佳类比？请从四个选项中选出正确答案。',
        stemText: source.stemText || '',
        options: source.options?.length === 4 ? source.options.map(item => ({
          ...item
        })) : emptyOptions(),
        rightAnswer: source.rightAnswer || 'A',
        analysisText: source.analysisText || ''
      };
    },
    insertBlank() {
      if (!this.form.stemText.includes('____')) {
        this.form.stemText = `${this.form.stemText}${this.form.stemText ? ' ' : ''}____`;
      }
    },
    async saveDraft() {
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) return;
      this.saving = true;
      try {
        const saved = await api.saveTextAnalogyDraft(this.form);
        ElMessage.success('草稿已保存');
        this.$emit('saved', saved);
      } finally {
        this.saving = false;
      }
    }
  }
};